export default "__VITE_ASSET__f3aa889d__"